import type { GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType } from './getExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType';

/**
 * 탐색 콘텐츠 기본 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwo = {
  type: GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType;
};
